import messageHandler from './messageHandler';
import errorList from '../assets/json/errorList';
import errorTitles from '../assets/json/errorTitles';

// * Helpers
// flat a nested object
const flattenObject = (obj, parentKey = '') => {
  let result = {};

  for (const key in obj) {
    const newKey = parentKey + capitalizeFirstLetter(key);

    if (typeof obj[key] === 'object') {
      const flattenedObj = flattenObject(obj[key], newKey);
      result = { ...result, ...flattenedObj };
    } else {
      result[newKey] = obj[key];
    }
  }

  return result;
};

// capitalize first letter of a string
const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);

// convert object key first letter to lower case
const convertKeysToLowerCase = obj => {
  const result = {};

  for (const key in obj) {
    const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
    result[lowerCaseKey] = obj[key];
  }

  return result;
};

// * Main function
export const CheckErrors = errors => {
  if (Object.keys(errors).length) {
    const errorsFlat = flattenObject(errors);
    const errorsLower = convertKeysToLowerCase(errorsFlat);
    const errorsMapped = Object.keys(errorsLower).map(
      field =>
        errorList[field][errorsLower[field]] ||
        `${errorTitles[field]}: ${errorsLower[field]}`
    );
    const message = (
      <div>
        <p>Corrija los siguientes errores para poder continuar:</p>
        {errorsMapped.map((error, i) => (
          <p key={i}>{error}</p>
        ))}
      </div>
    );

    messageHandler('error', message);
  }
};
